import { render, staticRenderFns } from "./ProjectRecord.vue?vue&type=template&id=b27e407e&scoped=true&"
import script from "./ProjectRecord.vue?vue&type=script&lang=js&"
export * from "./ProjectRecord.vue?vue&type=script&lang=js&"
import style0 from "../../css/newProjectDetail.css?vue&type=style&index=0&id=b27e407e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b27e407e",
  null
  
)

export default component.exports